const tw = 2;
module.exports = {
    'color-1': {
        name: 'Color 1',
        placeholderColor: 'rgb(211,207,201)',
        // fill all the blocks of this type, the whole wall
        fillAll: true,
        border: [
          // col 2
          [0, 0],
          [tw * 2, 0],
          [tw, 0],
          [tw, tw * 1],
          [tw * 2, tw * 1],
          [tw, tw * 1],
          [tw, tw * 2],
          [tw * 2, tw * 2],
          [tw, tw * 2],
    
          [tw, tw*7],
          [tw*2, tw*7],
          [tw, tw*7],
          [tw, tw*8],
          [tw*2, tw*8],
          [tw, tw*8],
          [tw, tw*9],
          [tw*2, tw*9],
          [tw, tw*9],
          [tw, tw*10],
          [tw*2, tw*10],
          [tw, tw*10],
          [tw, tw*11],
          [tw*2, tw*11],
          [tw, tw*11],
          [tw, tw*12],
          [tw*2, tw*12],
          [tw, tw*12],  
          [tw* 2, tw* 12],
          [tw * 2, 0],
          
          // col 4 
          [tw* 4, 0],
          [tw* 3, 0],
          [tw* 3, tw* 1],
          [tw* 4, tw* 1],
          [tw* 3, tw* 1],
          [tw* 3, tw* 2],
          [tw* 4, tw* 2],
          [tw* 3, tw* 2],
          [tw* 3, tw* 3],
          [tw* 4, tw* 3],
          [tw* 3, tw* 3],
          [tw* 3, tw* 4],
          [tw* 4, tw* 4],
          [tw* 3, tw* 4],
          [tw* 3, tw* 5],
          [tw* 4, tw* 5],
          [tw* 3, tw* 5],
          [tw* 3, tw* 6],
          [tw* 4, tw* 6],
          [tw* 3, tw* 6],
          [tw* 3, tw* 7],
          [tw* 4, tw* 7],
          [tw* 3, tw* 7],
          [tw* 3, tw* 8],
          [tw* 4, tw* 8],
          [tw*4, 0],
    
          // col 6
          [tw* 6, 0],
          [tw* 5, 0],
          [tw* 5, tw* 1],
          [tw* 6, tw* 1],
          [tw* 5, tw* 1],
          [tw* 5, tw* 2],
          [tw* 6, tw* 2],
          [tw* 5, tw* 2],
          [tw* 5, tw* 3],
          [tw* 6, tw* 3],
          [tw* 5, tw* 3],
          [tw* 5, tw* 4],
          [tw* 6, tw* 4],
          [tw* 5, tw* 4],
          [tw* 5, tw* 5],
          [tw* 6, tw* 5],
          [tw* 5, tw* 5], 
          [tw* 5, tw* 6],
          [tw* 6, tw* 6],
          [tw* 5, tw* 6],
          [tw* 5, tw* 7],
          [tw* 6, tw* 7],
          [tw* 5, tw* 7],
          [tw* 5, tw* 8],
          [tw* 6, tw* 8],
          [tw* 6, 0],
    
          // col 8
          [tw* 8, 0],
          [tw* 7, 0],
          [tw* 7, tw* 1],
          [tw* 8, tw* 1],
          [tw* 7, tw* 1],
          [tw* 7, tw* 2],
          [tw* 8, tw* 2],
          [tw* 7, tw* 2],
          [tw* 7, tw* 3],
          [tw* 8, tw* 3],
          [tw* 7, tw* 3],
          [tw* 7, tw* 4],
          [tw* 8, tw* 4],
          [tw* 7, tw* 4],
          [tw* 7, tw* 5],
          [tw* 8, tw* 5],
          [tw* 7, tw* 5],
          [tw* 7, tw* 6],
          [tw* 8, tw* 6],
          [tw* 7, tw* 6],
          [tw* 7, tw* 7],
          [tw* 8, tw* 7],
          [tw* 7, tw* 7],
          [tw* 7, tw* 8],
          [tw* 8, tw* 8],
          [tw* 8, 0],
    
          // col 10
          [tw* 10, 0],
          [tw* 9, 0],
          [tw* 9, tw* 1],
          [tw* 10, tw* 1],
          [tw* 9, tw* 1],
          [tw* 9, tw* 2],
          [tw* 10, tw* 2],
          [tw* 9, tw* 2],
          [tw* 9, tw* 7],
          [tw* 9, tw* 8],
          [tw* 9, tw* 7],
          [tw* 10, tw* 7],
          [tw* 9, tw* 7],
          [tw* 9, tw* 8],
          [tw* 10, tw* 8],
          [tw* 9, tw* 8],
          [tw* 9, tw* 9],
          [tw* 10, tw* 9],
          [tw* 9, tw* 9],
          [tw* 9, tw* 10],
          [tw* 10, tw* 10],
          [tw* 9, tw* 10],
          [tw* 9, tw* 11],
          [tw* 10, tw* 11],
          [tw* 9, tw* 11],
          [tw* 9, tw* 12],
          [tw* 10, tw* 12],
          [tw* 10, 0],
    
          // col 12
          [tw* 12, 0],
          
          [tw* 11, 0],
          [tw* 11, tw* 1],
          [tw* 12, tw* 1],
          [tw* 11, tw* 1],
          [tw* 11, tw* 2],
          [tw* 12, tw* 2],
          [tw* 11, tw* 2],
          [tw* 11, tw* 7],
          [tw* 11, tw* 8],
          [tw* 11, tw* 7],
          [tw* 12, tw* 7],
          [tw* 11, tw* 7],
          [tw* 11, tw* 8],
          [tw* 12, tw* 8],
          [tw* 11, tw* 8],
          [tw* 11, tw* 9],
          [tw* 12, tw* 9],
          [tw* 11, tw* 9],
          [tw* 11, tw* 10],
          [tw* 12, tw* 10],
          [tw* 11, tw* 10],
          [tw* 11, tw* 11],
          [tw* 12, tw* 11],
          [tw* 11, tw* 11],
          [tw* 11, tw* 12],
          [tw* 12, tw* 12],
          [tw* 12, 0],
        ]
    },
    'color-2': {
        name: 'Color 2',
        placeholderColor: 'rgb(159,160,162)',
        // fill all the blocks of this type, the whole wall
        fillAll: true,
        border: [
          // col 1
          [0, 0],
          [0, tw*8],
          [tw, tw*8],
          [0, tw*8],
          [0, tw*9],
          [tw, tw*9],
          [0, tw*9],
          [0, tw*10],
          [tw, tw*10],
          [0, tw*10],
          [0, tw*11],
          [tw, tw*11],
          [0, tw*11],
          [0, tw*12],
          [tw, tw*12],
          [tw, tw* 8],
          [0, tw* 8],
          [0, 0],
          // col 5
          [tw* 4, 0],
          [tw* 4, tw* 2],
          [tw* 5, tw* 2],
          [tw* 4, tw* 2],
          [tw* 4, tw* 3],
          [tw* 5, tw* 3],
          [tw* 4, tw* 3],
          [tw* 4, tw* 4],
          [tw* 5, tw* 4],
          [tw* 4, tw* 4],
          [tw* 4, tw* 5],
          [tw* 5, tw* 5],
          [tw* 4, tw* 5],
          [tw* 4, tw* 6],
          [tw* 5, tw* 6],
          [tw* 5, tw* 2],
          [tw* 4, tw* 2],
          [tw* 4, 0],
          //col 7 same as 5
          [tw* 6, 0],
          [tw* 6, tw* 2],
          [tw* 7, tw* 2],
          [tw* 6, tw* 2],
          [tw* 6, tw* 3],
          [tw* 7, tw* 3],
          [tw* 6, tw* 3],
          [tw* 6, tw* 4],
          [tw* 7, tw* 4],
          [tw* 6, tw* 4],
          [tw* 6, tw* 5],
          [tw* 7, tw* 5],
          [tw* 6, tw* 5],
          [tw* 6, tw* 6],
          [tw* 7, tw* 6],
          [tw* 7, tw* 2],
          [tw* 6, tw* 2],
          [tw* 6, 0],
    
          // col 11 4 squares at bottom
          [tw* 10, 0],
          [tw* 10, tw* 8],
          [tw*11, tw* 8],
          [tw* 10, tw* 8],
          [tw* 10, tw* 9],
          [tw*11, tw* 9],
          [tw* 10, tw* 9],
          [tw* 10, tw* 10],
          [tw*11, tw* 10],
          [tw* 10, tw* 10],
          [tw* 10, tw* 11],
          [tw*11, tw* 11],
          [tw* 10, tw* 11],
          [tw* 10, tw* 12],
          [tw*11, tw* 12],
          [tw*11, tw* 8],
          [tw* 10, tw* 8],
    
    
          [tw* 10, 0],
    
    
        ],
    },
    'color-3': {
        name: 'Color 3',
        placeholderColor: 'rgb(105,106,110)',
        // fill all the blocks of this type, the whole wall
        fillAll: true,
        border: [
          // col 2 - has to be enclosing because it will be a polygon
          [0, 0],
          [0, tw * 2],
          [tw, tw * 2],
          [tw, tw * 3],
          [tw, tw * 2],
          [tw * 2, tw * 2],
          [tw * 2, tw * 3],
          [tw, tw * 3],
          [tw * 2, tw * 3],
          [tw * 2, tw * 4],
          [tw, tw * 4],
          [tw, tw * 3],
          [tw, tw * 4],
          [tw * 2, tw * 4],
          [tw * 2, tw * 5],
          [tw, tw * 5],
          [tw, tw * 4],
          [tw, tw * 5],
          [tw * 2, tw * 5],
          [tw * 2, tw * 6],
          [tw, tw * 6],
          [tw, tw * 5],
          [tw, tw * 6],
          [tw * 2, tw * 6],
          [0, tw * 6],
          [0, tw * 5],
          [tw, tw * 5],
          [0, tw * 5],
          [0, tw * 4],
          [tw, tw * 4],
          [0, tw * 4],
          [0, tw * 3],
          [tw, tw * 3],
          [0, tw * 3],
          [0, tw * 2],
    
          // 3 col
          [0, tw* 6],
          [tw * 2, tw * 6],
          [tw * 2, tw * 12],
          [tw * 3, tw * 12],      
          [tw * 3, tw * 11],
          [tw * 2, tw * 11],
          [tw * 3, tw * 11],
          [tw * 3, tw * 10],
          [tw * 2, tw * 10],
          [tw * 3, tw * 10],
          [tw * 3, tw * 9],
          [tw * 2, tw * 9],
          [tw * 3, tw * 9],
          [tw * 3, tw * 8],
          [tw * 2, tw * 8],
          [tw * 3, tw * 8],
          [tw * 2, tw* 8],
    
          // 5 col
          [tw* 4, tw* 8],
          [tw* 5, tw* 8],
          [tw* 4, tw* 8],
          [tw* 4, tw* 9],
          [tw* 5, tw* 9],
          [tw* 4, tw* 9],
          [tw* 4, tw* 10],
          [tw* 5, tw* 10],
          [tw* 4, tw* 10],
          [tw* 4, tw* 11],
          [tw* 5, tw* 11],
          [tw* 4, tw* 11],
          [tw* 4, tw* 12],
          [tw* 5, tw* 12],
          [tw* 5, tw* 8],
    
          // 7col 
          [tw* 6, tw* 8],
          [tw* 7, tw* 8],
          [tw* 6, tw* 8],
          [tw* 6, tw* 9],
          [tw* 7, tw* 9],
          [tw* 6, tw* 9],
          [tw* 6, tw* 10],
          [tw* 7, tw* 10],
          [tw* 6, tw* 10],
          [tw* 6, tw* 11],
          [tw* 7, tw* 11],
          [tw* 6, tw* 11],
          [tw* 6, tw* 12],
          [tw* 7, tw* 12],
          [tw* 7, tw* 8],
    
          // 8col 
          [tw* 7, tw* 12],
          [tw* 8, tw* 12],
          [tw* 8, tw* 11],
          [tw* 7, tw* 11],
          [tw* 8, tw* 11],
          [tw* 8, tw* 10],
          [tw* 7, tw* 10],
          [tw* 8, tw* 10],
          [tw* 8, tw* 9],
          [tw* 7, tw* 9],
          [tw* 8, tw* 9],
          [tw* 8, tw* 8],
          [tw* 7, tw* 8],
          [tw* 8, tw* 8],
    
          // 10col
          [tw* 8, tw* 6],
          [tw* 9, tw* 6],
          [tw* 8, tw* 6],
          [tw* 8, tw* 5],
          [tw* 9, tw* 5],
          [tw* 8, tw* 5],
          [tw* 8, tw* 4],
          [tw* 9, tw* 4],
          [tw* 8, tw* 4],
          [tw* 8, tw* 3],
          [tw* 9, tw* 3],
          [tw* 8, tw* 3],
          [tw* 8, tw* 2],
          [tw* 9, tw* 2],
          [tw* 9, tw* 6],
    
          // 11 col
          [tw* 10, tw* 6],
          [tw* 11, tw* 6],
          [tw* 10, tw* 6],
          [tw* 10, tw* 5],
          [tw* 11, tw* 5],
          [tw* 10, tw* 5],
          [tw* 10, tw* 4],
          [tw* 11, tw* 4],
          [tw* 10, tw* 4],
          [tw* 10, tw* 3],
          [tw* 11, tw* 3],
          [tw* 10, tw* 3],
          [tw* 10, tw* 2],
          [tw* 11, tw* 2],
          [tw* 11, tw* 6],
    
          [tw* 8, tw* 6],
          [tw* 8, tw* 8],
          [tw* 2, tw* 8],
          [tw* 2, tw* 6],
          [0, tw* 6],
    
          
    
        ]
      },
    'color-4': {
        name: 'Color 4',
        // fill all the blocks of this type, the whole wall
        fillAll: true,
        placeholderColor: 'rgb(63,67,72)',
        border: [
          // darkest color
          // darkest - col 1
          [0, 0],
          [tw, 0],
          [tw, tw * 1],
          [0, tw * 1],
          
          [0, 0],
          [0, tw * 2],    
          [tw, tw * 2],
          [tw, tw],
          [0, tw],
          
          [0, 0],
          [0, tw * 3],    
          [tw, tw * 3],
          [tw, tw],
          [0, tw],
    
          [0, 0],
          [0, tw * 4],    
          [tw, tw * 4],
          [tw, tw],
          [0, tw],
    
          [0, tw * 5],    
          [tw, tw * 5],
          [tw, tw],
          [0, tw],
    
          [0, tw * 6],    
          [tw, tw * 6],
          [tw, tw],
          [0, tw],
    
          [0, tw * 7],
          [tw, tw * 7],
          [tw, tw],
          [0, tw],
          
          [0, tw * 8],
          [tw, tw * 8],
          [tw, tw],
          [0, tw],
    
          // darkest col 3
          [0, 0],
          [tw * 2, 0],    
          [tw * 3, 0],
          [tw * 3, tw * 1],
          [tw * 2 , tw * 1],
          [tw * 2, 0], 
    
          [tw * 2, 0],    
          [tw * 2, tw],    
          [tw * 3, tw],
          [tw * 3, tw * 2],
          [tw * 2 , tw * 2],
          [tw * 2, 0],  
    
          [tw * 2, tw* 6],
          [tw * 3, tw* 6],
          [tw * 2, tw* 6],
          [tw * 2, tw* 7],
          [tw * 3, tw* 7],
          [tw * 2, tw* 7],
          [tw * 2, tw* 8],
          [tw * 3, tw* 8],
          [tw * 2, tw* 8],
          [tw * 2, tw* 9],
          [tw * 3, tw* 9],
          [tw * 2, tw* 9],
          [tw * 2, tw* 10],
          [tw * 3, tw* 10],
          [tw * 2, tw* 10],
          [tw * 2, tw* 11],
          [tw * 3, tw* 11],
          [tw * 2, tw* 11],
          [tw * 2, tw* 12],
          [tw * 3, tw* 12],
          [tw * 3, tw* 6],
          [tw* 2, tw* 6],
          [tw* 2, 0],
    
          // col 5
          [tw*5, 0],
          [tw* 4, 0],
          [tw* 4, tw* 1],
          [tw* 5, tw* 1],
          [tw* 4, tw* 1],
          [tw* 4, tw*2],
          [tw* 5, tw*2],
          [tw* 5, 0],
    
          [tw* 4 , 0],
          [tw*4, tw* 12],
          [tw* 5, tw* 12],
          [tw* 5, tw* 11],
          [tw* 4, tw* 11],
          [tw* 5, tw* 11],
          [tw* 5, tw* 10],
          [tw* 4, tw* 10],
          [tw* 5, tw* 10],
          [tw* 5, tw* 9],
          [tw* 4, tw* 9],
          [tw* 5, tw* 9],
          [tw* 5, tw* 8],
          [tw* 4, tw* 8],
          [tw* 5, tw* 8],
          [tw* 5, tw* 7],
          [tw* 4, tw* 7],
          [tw* 5, tw* 7],
          [tw* 5, tw* 6],
          [tw* 4, tw* 6],
          [tw* 4, 0],
          [tw* 5, 0],
          // col 7
          [tw* 7, 0],
          [tw* 6, 0],
          [tw* 6, tw* 1],
          [tw* 7, tw* 1],
          [tw* 6, tw* 1],
          [tw* 6, tw*2],
          [tw* 7, tw*2],
          [tw* 7, 0],
    
          [tw* 6 , 0],
          [tw*6, tw* 12],
          [tw* 7, tw* 12],
          [tw* 7, tw* 11],
          [tw* 6, tw* 11],
          [tw* 7, tw* 11],
          [tw* 7, tw* 10],
          [tw* 6, tw* 10],
          [tw* 7, tw* 10],
          [tw* 7, tw* 9],
          [tw* 6, tw* 9],
          [tw* 7, tw* 9],
          [tw* 7, tw* 8],
          [tw* 6, tw* 8],
          [tw* 7, tw* 8],
          [tw* 7, tw* 7],
          [tw* 6, tw* 7],
          [tw* 7, tw* 7],
          [tw* 7, tw* 6],
          [tw* 6, tw* 6],
          [tw* 6, 0],
          [tw* 7, 0],
          // col 9
          [tw* 9, 0],
          [tw* 8, 0],
          [tw* 8, tw* 1],
          [tw* 9, tw* 1],
          [tw* 8, tw* 1],
          [tw* 8, tw*2],
          [tw* 9, tw*2],
          [tw* 8, tw*2],
          [tw* 8, tw*3],
          [tw* 9, tw*3],
          [tw* 8, tw*3],
          [tw* 8, tw*4],
          [tw* 9, tw*4],
          [tw* 8, tw*4],
          [tw* 8, tw*5],
          [tw* 9, tw*5],
          [tw* 8, tw*5],
          [tw* 8, tw*6],
          [tw* 9, tw*6],
          [tw* 8, tw*6],
          [tw* 8, tw*7],
          [tw* 9, tw*7],
          [tw* 8, tw*7],
          [tw* 8, tw*8],
          [tw* 9, tw*8],
          [tw* 9, 0],
    
          // col 11 - same as 9
          [tw* 11, 0],
          [tw* 10, 0],
          [tw* 10, tw* 1],
          [tw* 11, tw* 1],
          [tw* 10, tw* 1],
          [tw* 10, tw*2],
          [tw* 11, tw*2],
          [tw* 10, tw*2],
          [tw* 10, tw*3],
          [tw* 11, tw*3],
          [tw* 10, tw*3],
          [tw* 10, tw*4],
          [tw* 11, tw*4],
          [tw* 10, tw*4],
          [tw* 10, tw*5],
          [tw* 11, tw*5],
          [tw* 10, tw*5],
          [tw* 10, tw*6],
          [tw* 11, tw*6],
          [tw* 10, tw*6],
          [tw* 10, tw*7],
          [tw* 11, tw*7],
          [tw* 10, tw*7],
          [tw* 10, tw*8],
          [tw* 11, tw*8],
          [tw* 11, 0],
        ]
    },
}


// WEBPACK FOOTER //
// ./src/universal/filzfelt/blocks/twill.js